<template>
  <div>
    <p class="title">预制发票明细表</p>
    <div>
      <span class="head-box">
        <span>公司主体：</span>
        {{info.company}}
      </span>
      <!-- <span class="head-box">
        <span class="box"></span>
        2003珠海赫基服饰有限公司
      </span>
      -->
      <span>
        <span>发票流水号：</span>
        {{info.invoiceOrderNo}}
      </span> 
    </div>
    <div class="company">
      <span>供应商代码/名称：<span class="code">{{info.code}}</span><span class="code">{{info.name}}</span><span class="type">发票类型：{{info.type}}</span></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "print-company",
  props: {
    info:{
      type: Object, 
      default: {}
    }
  }
};
</script>

<style scoped>
.title {
  text-align: center;
  font-weight: 500;
  font-size: 6mm;
}
.head-box {
  display: inline-block;
  width: 300px;
  margin-right: 155px;
}
.box {
  display: inline-block;
  width: 15px;
  height: 20px;
  border: 1px solid #000;
}
.company {
  margin: 5px 0;
}
.company .code {
  margin: 0 20px;
}
.company .type {
  margin: 0 40px;
}
</style>